import { useEffect, useRef } from 'react';
import mapboxgl, { Map as MapBox } from 'mapbox-gl';
import { MapHelper } from './MapHelper';
import 'mapbox-gl/dist/mapbox-gl.css';

const Map = () => {
    const mapRef = useRef<MapBox>(null);
    const mapContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        mapboxgl.accessToken = 'pk.eyJ1IjoidG9rYXJldmVrIiwiYSI6ImNtZ2x6cmV6dTBmemUya3M3OWVqdjV0MGgifQ.j1TxdJCuaUF8hZkwNCNDsQ';
        // @ts-ignore
        mapRef.current = new mapboxgl.Map({
            container: mapContainerRef.current!,
            center: [55.27409, 25.197311],
            zoom: 15.5,
            pitch: 65,
            bearing: 0,
            style: 'mapbox://styles/mapbox/standard',
            minZoom: 10,
            maxZoom: 20,
            config: {
                basemap: {
                    lightPreset: 'day',
                    showPlaceLabels: true,
                    showPointOfInterestLabels: false,
                    showRoadLabels: true,
                    showTransitLabels: true
                }
            }
        });

        const mapHelper = new MapHelper(mapRef.current);

        new mapboxgl.Marker()
            .setLngLat([55.27409, 25.197311])
            .addTo(mapRef.current);
        new mapboxgl.Marker()
            .setLngLat([55.350639, 25.134500])
            .addTo(mapRef.current);

        mapRef.current.on('style.load', () => {
            if (!mapRef.current) {
                return;
            }

            mapHelper.enableClickDebug();
            mapRef.current.addControl(new mapboxgl.FullscreenControl());

            // Add burj khalifa to map;
            mapHelper.addModelToMap(
                'https://dubai-dream.vercel.app/burj_khalifa_dubai.glb',
                [[
                    [55.2734261926459, 25.197707271843058],
                    [55.274997190677624, 25.197528626076476],
                    [55.274063656006064, 25.19637601516372],
                    [55.2734261926459, 25.197707271843058],
                ]],
                [55.27347766182697, 25.196404087761394],
                [0.0, 0.0, -1],
                [0.025, 0.025, 0.025]
            );
        });
    }, []);

    return (
        <div ref={mapContainerRef} style={{ height: '100vh' }} />
    );
};

export default Map;